import { makeAutoObservable, runInAction } from "mobx";

export default class typeOfToolStore {
  typeOfTool = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.typeOfTool = [];
    runInAction(() => {
      this.typeOfTool = data;
    });
  };

  deleteTypeOfTool = (id) => {
    let newState = this.typeOfTool.filter((typeOfTool) => typeOfTool.id !== id);
    this.typeOfTool = [];
    this.typeOfTool = newState;
  };
}